import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from '../../components/Toolbar/Toolbar';
import CardContent from '@material-ui/core/CardContent/CardContent';
import Card from '@material-ui/core/Card/Card';
import NoteProjectContactEdit from '../../components/Notes/NoteProjectContactEdit';
import RenderContactDetailsFragment from '../../components/Contacts/RenderContactDetailsFragment';
import RenderDetailsRow from '../../components/Formater/RenderDetailsRow';
import {Link, withStyles} from '@material-ui/core';
import LongTextButton from '../../components/Text/LongTextButton';
import FormaterDate from '../../components/Formater/Date';
import iconNames from '../../components/Formater/IconNames';
import LinkIconButton from '../../components/Formater/LinkIconButton';
import Divider from '@material-ui/core/Divider';
import Icon from '@material-ui/core/Icon';
import {ContactData} from '../../components/Notes/NoteListItem';

const ProjectContactNoteShow = ({classes, note, projectContactNote}) => {
    const {project, contact, user, communication_ident, communication_name, note_content, reminder, title} = projectContactNote || {};
    const {detailsLabelWithButton} = classes;

    return (
        <Layout>
            <Toolbar
                disableGutters
                title={i18n.get('notes.details')}
            />

            <Card>
                <CardContent>
                    <RenderDetailsRow label={i18n.get('notes.created_at')} value={note.created_at}>
                        <FormaterDate hour={'2-digit'}
                                      minute={'2-digit'}
                                      value={note.created_at}/>
                        {note.creator && '(' + note.creator.name + ')'}
                    </RenderDetailsRow>
                    <RenderDetailsRow label={i18n.get('notes.title')} value={title} />
                    <RenderDetailsRow label={i18n.get('notes.communication_ident')} value={communication_ident}>
                        <ContactData note={projectContactNote} />
                    </RenderDetailsRow>
                    <RenderDetailsRow label={i18n.get('notes.user')} value={user ? user.name : null} />
                    <RenderDetailsRow label={i18n.get('notes.reminder')} value={reminder} >
                        <Icon className={classes.reminderIcon}>alarm</Icon>
                        <FormaterDate value={reminder} />
                    </RenderDetailsRow>
                    {project && (
                        <RenderDetailsRow label={i18n.get('mailing.project')} value={project} labelClass={detailsLabelWithButton}>
                            <LinkIconButton
                                text={project.name}
                                href={`/project/${project.id}`}
                                icon={iconNames.project}
                            />
                        </RenderDetailsRow>
                    )}

                    <RenderDetailsRow label={i18n.get('notes.contact')} value={contact}>
                        <RenderContactDetailsFragment contact={contact}/>
                    </RenderDetailsRow>
                    <Divider />
                    <RenderDetailsRow label={i18n.get('notes.note')} value={note_content} labelClass={detailsLabelWithButton}>
                        <LongTextButton short={note_content && note_content.substr(0, 200)} long={note_content}/>
                    </RenderDetailsRow>
                </CardContent>
            </Card>
        </Layout>);
};

const styles = theme => ({
    detailsLabelWithButton: {
        lineHeight: '32px',
    },
    reminderIcon: {
        fontSize: '12px',
        paddingRight: theme.spacing.unit,
    }
});

export default withStyles(styles)(ProjectContactNoteShow);
